import styled from 'styled-components/macro';
import Select from 'react-select';
import { getSelectAnimation } from 'styles/animations.styled';

export const StyledSelect = styled(Select)<{
  collapsed: boolean;
}>`
  .worker__control {
    border: 1px solid #ced5de;
    animation-name: ${(props) => getSelectAnimation(props.collapsed)};
    animation-delay: 0s;
    animation-duration: 300ms;
    transition: 150ms all;
  }
`;
